import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    totalQuantity: 0,
    totalCost: 0,
};

const getters = {
    totalQuantity: state => state.totalQuantity,

    totalCost: state => state.totalCost,
};

const mutations = {
    setTotalQuantity(state, data) {
        state.totalQuantity = data;
    },

    setTotalCost(state, data) {
        state.totalCost = data;
    },
};

const actions = {
    async getSummary({ commit, dispatch }, params) {
        const url = Laroute.route('inventory.cost.good.sold.summary');

        startLoading(dispatch, 'get-total-quantity');
        startLoading(dispatch, 'get-total-cost');

        const { data } = await axios.post(url, params);

        return data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/cost-good-sold.js